import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Popover,
  Stack,
} from "@mui/material";
import Typography from "components/basic/typography";
import Button from "components/basic/button";
import { BookingType, EVENT_TYPES } from "../../../eventTypes";

interface FilterMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  selected: BookingType[];
  onChange: (selected: BookingType[]) => void;
}

const FilterMenu: React.FC<FilterMenuProps> = ({
  anchorEl,
  open,
  onClose,
  selected,
  onChange,
}) => {
  const { t } = useTranslation("calendar");
  const toggle = (id: BookingType) =>
    onChange(
      selected.includes(id)
        ? selected.filter((selectedId) => selectedId !== id)
        : [...selected, id],
    );

  const allIds = EVENT_TYPES.map((type) => type.id);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box sx={{ p: 2, width: 240 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
          {t("filter.title")}
        </Typography>
        <Stack sx={{ mt: 1 }}>
          {EVENT_TYPES.map((type) => (
            <FormControlLabel
              key={type.id}
              control={
                <Checkbox
                  size="small"
                  checked={selected.includes(type.id)}
                  onChange={() => toggle(type.id)}
                  sx={{
                    color: type.color,
                    "&.Mui-checked": { color: type.color },
                  }}
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "3px",
                      backgroundColor: type.color,
                    }}
                  />
                  <Typography variant="body2">{type.label}</Typography>
                </Box>
              }
            />
          ))}
        </Stack>

        <Divider sx={{ my: 1 }} />
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="text" color="primary" onClick={() => onChange([])}>
            {t("filter.clear")}
          </Button>
          <Button
            variant="text"
            color="warning"
            onClick={() => onChange(allIds)}
          >
            {t("filter.show_all")}
          </Button>
        </Stack>
      </Box>
    </Popover>
  );
};

export default FilterMenu;
